module.exports = __webpack_public_path__ + "static/Video 30 años-070c733382afa6267ba6fcf47d9f3c9c.mp4";